export const PAYMENT_CONFIRM_CHECK_DELAY_MS = 1000
